<div class="chart-container" *ngIf="(!isLoading && errorToShow == null)"  >
  <cre-spinner
    [size]="'md'"
    [hidden]="!isLoading"
    class="chart-spinner "
  ></cre-spinner>
  <div *ngIf="(!isLoading && errorToShow == null)" class="chart-content">
    <div class="chart-header">
      <div>
        <div class="header-title">
          Wildly Important Goal
        </div>
        <div class="header-names">
          <div class="header-left-space">

          </div>
          <div class="header-goal-space ">
            <span>Goal %</span>
          </div>
          <div class="header-date-space ">
            <span>Week Ending {{monthToShow}}/{{dateToShow}}</span>
          </div>
        </div>
        <div class="header-results">
          <div class="header-left-space">
            <div class="header-left-space-battle">
              <span>{{battleName}}</span>
            </div>
            <div class="header-left-space-battle-result">
              <span
                class="status"
                *ngIf="(charInformation.battleStatus !== 'N/A')"
                [ngClass]="getStatusClass(charInformation.battleStatus)"
              >{{
                charInformation.battleStatus
                }}</span>
            </div>
          </div>
          <div class="header-goal-space-result">
            <span>{{goalToShow}}</span>
          </div>
          <div class="header-date-space-result">
            <span>{{charInformation.resultsLastWeek.toFixed(2)}}%</span>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-display">
      <div class="header-title">
        Weekly Results
      </div>
      <div class="chart-body">
        <p-chart
          [data]="chartData"
          height="100%"
          [options]="chartOptions"
          type="bar"
          width="100%"
        ></p-chart>
        <div
          class="overlay-no-data"
          *ngIf="!hasData"
        >
          <div class="no-data">
            <span><fa-icon
                class="cre-stat-panel-value"
                [icon]="['fal', 'gas-pump-slash']"
              ></fa-icon></span>
            <div class="no-data-available">
              <span class="no-data-available">No Data Available. Please check back later</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Lead Measure  -->
    <div class="lead-display">
      <div class="header-title">
        Lead Measure
      </div>
      <div class="lead-content">
        <div class="header-names">
          <div class="header-left-space">

          </div>
          <div class="header-goal-space ">
            <span>Goal %</span>
          </div>
          <div class="header-date-space ">
            <span>Week Ending {{monthToShow}}/{{dateToShow}}</span>
          </div>
        </div>

        <div class="header-results">
          <div class="header-left-space">
            <div class="header-left-space-battle">
              <span>Daily Commitment Response</span>
            </div>
            <div class="header-left-space-battle-result">
              <span
                class="status"
                *ngIf="(leadInformation.status !== 'N/A')"
                [ngClass]="getStatusClass(leadInformation.status)"
              >{{
                leadInformation.status
                }}</span>
            </div>
          </div>

          <div class="header-goal-space-result">
            <span>{{leadGoalToShow}}</span>
          </div>
          <div class="header-date-space-result">
            <span>{{leadInformation.resultsLastWeek.toFixed(2)}}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
